import Image from 'next/image';
import Link from 'next/link';
import { type PropsWithChildren } from 'react';

import { type NavItem } from '@/api/types/navigationTypes';
import { cn } from '@/utils/ui';

interface PackageSelectNavItemProps {
  navItem: NavItem;
  className?: string;
  isActive?: boolean;
}

export function PackageSelectNavItem(props: PropsWithChildren<PackageSelectNavItemProps>): React.ReactNode {
  const { navItem, className, isActive, children } = props;

  const { nav_item_id, item_key, images } = navItem;
  const { canonicalName, displayName } = navItem.parsedProps;

  return (
    <li
      key={nav_item_id}
      className={cn(
        'mb-3 pt-3 font-FoxOneAeroBold text-[17px]/[22px]',
        {
          'text-base-white/50': !isActive,
          'text-white': isActive,
        },
        className,
      )}
    >
      <Link
        href={isActive ? `/${item_key}` : `/mlp/${item_key.replace(/_/g, '-')}`}
        className="group flex items-center justify-between rounded-lg p-4 font-FoxOneAeroBold text-[17px]/[22px] text-base-white/50 hover:bg-base-white/10 hover:text-white focus:outline-none focus-visible:bg-base-white/10 focus-visible:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
        data-analytics={`header-package-select-button-${canonicalName}`}
      >
        <div className="flex w-full items-center">
          {images?.logo ? (
            <Image
              className={cn(
                'h-[23px] w-auto transition-opacity duration-200',
                {
                  'h-[24px]': item_key === 'fox_nation',
                  'h-[18px]': item_key === 'fox_one',
                  'h-[28px]': item_key === 'big_ten',
                },
                !isActive && 'opacity-50 group-hover:opacity-100',
              )}
              src={images.logo}
              alt={`${displayName} icon`}
              width={240}
              height={28}
            />
          ) : (
            <span>{displayName}</span>
          )}
        </div>
        {children}
      </Link>
    </li>
  );
}
